module.exports = __webpack_public_path__ + "static/media/blood-sample.afc0b7ad.png";